package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.delete_addition


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DeleteProductAddition(
    @SerialName("id")
    val id: String?,
    @SerialName("__typename")
    val typename: String?
)